




















































































































































































































































































































































import Vue, { PropOptions } from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
// import * as models from '@/class/models/views/app';
import * as models from '@/class/models/views/graph';
import * as models_app from '@/class/models/views/app';
import NOC from '@/class/common/const';
import * as NOCArray from '@/personal/array';
import ClickOutside from 'vue-click-outside';
import API from '@/api/common';
import * as alertModels from '@/class/models/views/alert';
import InfiniteLoading from 'vue-infinite-loading';
import * as Talert from '@/class/models/typed/alert';
import Dashboard from '@/views/Dashboard.vue';
import { isRoleAdmin, isRoleAdminOrManager } from '@/class/common/util/role_util';
import { isRoleExternalAdminOrManager, isRoleWithoutInternalAdmin } from '@/util/role-util-frontend';

interface Data {
  modalShowFlag2: boolean;
  modalShowFlag3: boolean;
  navHover: boolean;
  // navHover2: boolean;
  // navHover3: boolean;
  newNewsCount: string;
  // displayedItemIndex: number;
  displayedItems: Talert.INewsAlert[];
  minAlertID: number;
  alertList: Talert.INewsAlert[];
  noAlertList: Talert.INewsAlert[];
  noAlertFlag: boolean;
  selectMaxCount: number;
  infiniteId: number;
  // myValues: models.IValues;
  nextPage: number;
  loading: boolean;
}
interface Methods {
  onClickAlert: () => void;
  onDetailModalClose: () => void;
  onAnotherModal: () => void;
  onAlertModalClose: () => void;
  windowOpen: (path: string) => void;
  onPushPath: (
    path: string,
    fromHamburger: boolean,
    index?: any,
    item?: any,
  ) => void;
  newsCount: () => string;
  isActivePath: (path: string) => boolean;
  tryGetClassActiveByPaths: (paths: string[]) => string;
  tryGetClassActiveByPath: (path: string) => string;
  onClickShowGadgetEditer: () => void;
  onClickShowAddGadget: () => void;
  onClickSPMenuOutSide: () => void;
  getAlertList: () => Promise<void>;
  infiniteHandler: ($state: any) => Promise<void>;
  setNoAlertList: () => void;
}
interface Computed {
  IS_ROLE_ADMIN_OR_MANAGER_WITHOUT_INNER_ADMIN: boolean;
  IS_ROLE_ALL_WITHOUT_INNER_ADMIN: boolean;
  IS_ROLE_ADMIN: boolean;
  IS_ROLE_ADMIN_OR_MANAGER: boolean;
  DISP_ROLE: string;
  urlTop: boolean;
  AVAILABLE_CONTRACT: boolean;
  LICENSE_NOTIFICATION_CONTRACT: boolean;
}
interface Props {
  appData: models_app.IAPP;
  dispClick: boolean;
  ownerFlag: boolean;
  newsList: [];
  alertCount: number;
  nowPath: string;
  login: boolean;
}

export default Vue.extend({
  name: 'TopBar',
  components: { InfiniteLoading },
  props: {
    appData: Object as PropOptions<models_app.IAPP>,
    dispClick: Boolean,
    ownerFlag: Boolean,
    newsList: Array,
    alertCount: Number,
    nowPath: String,
    login: Boolean,
  },
  data() {
    return {
      // modalShowFlag: false,
      modalShowFlag2: false,
      modalShowFlag3: false,
      navHover: false,
      // navHover2: false,
      // navHover3: false,
      // roleText: '',
      newNewsCount: '0',
      displayedItems: [] as Talert.INewsAlert[],
      minAlertID: 0,
      alertList: [] as Talert.INewsAlert[],
      noAlertList: [] as Talert.INewsAlert[],
      noAlertFlag: false,
      selectMaxCount: 0,
      infiniteId: 0,
      // myValues: {} as models.IValues,
      nextPage: 0,
      loading: true,
      //   displayedItems: [
      //   {id: 1, title: "今後のアップデートについて", date: "2022.07.10 15:42" },
      //   {id: 2,title: "佐々木あゆみ さんの残業時間が指定時間を超えました。",date: "2022.07.10 15:42"},
      //   {id: 3,title: "村山了 さんが休日勤務をしました。",date: "2022.07.10 15:42"},
      //   {id: 4, title: "和田明宏 さんの勤務間インターバルが指定時間を下回りました。",date: "2022.07.10 15:42"},
      //   {id: 5,title: "和田明宏 さんが禁止アプリ「youtube」を使用しました。",date: "2022.07.10 15:42"},
      //   {id: 6,title: "2020年6月分の月間レポート",date: "2022.07.10 15:42"},
      //   {id: 7, title: "今後のアップデートについて2", date: "2022.07.10 15:42" },
      //   {id: 8,title: "佐々木あゆみ さんの残業時間が指定時間を超えました。2",date: "2022.07.10 15:42"      },
      //   {id: 9,title: "村山了 さんが休日勤務をしました。2",date: "2022.07.10 15:42"},
      //   {id: 10, title: "和田明宏 さんの勤務間インターバルが指定時間を下回りました。2",date: "2022.07.10 15:42"},
      //   {id: 11,title: "和田明宏 さんが禁止アプリ「youtube」を使用しました。2",date: "2022.07.10 15:42"},
      //   {id: 12,title: "2020年6月分の月間レポート2",date: "2022.07.10 15:42"},
      // ]
    };
  },
  async mounted() {
    await this.getAlertList();

    // infiniteLoading開始
    this.loading = false;
    // (this.$refs.infiniteLoading as any).stateChanger.reset();
  },
  computed: {
    // ダッシュボードを閲覧できる権限か？
    IS_ROLE_ADMIN_OR_MANAGER_WITHOUT_INNER_ADMIN(): boolean {
      return isRoleExternalAdminOrManager(this.appData.role);
    },
    IS_ROLE_ALL_WITHOUT_INNER_ADMIN(): boolean {
      return isRoleWithoutInternalAdmin(this.appData.role);
    },
    IS_ROLE_ADMIN(): boolean {
      return isRoleAdmin( this.appData.role );
    },
    IS_ROLE_ADMIN_OR_MANAGER(): boolean {
      return isRoleAdminOrManager( this.appData.role );
    },
    DISP_ROLE(): string {
      return NOCArray.getOptionsText(NOCArray.ROLE, this.appData.role);
    },
    urlTop() {
      return this.$route.path === '/';
    },
    AVAILABLE_CONTRACT(): boolean {
      switch (this.appData.contractStatus) {
        case NOC.CONTRACT.QUIT:
        case NOC.CONTRACT.CONFIRM:
        case NOC.CONTRACT.STOP:
        case NOC.CONTRACT.DENY:
          return false;
        default:
          return true;
      }
    },
    LICENSE_NOTIFICATION_CONTRACT(): boolean {
      switch (this.appData.contractStatus) {
        case NOC.CONTRACT.DELAY:
        case NOC.CONTRACT.CONFIRM:
        case NOC.CONTRACT.STOP:
          return true;
        default:
          return false;
      }
    },
  },
  watch: {
    dispClick() {
      this.onDetailModalClose();
    },
    // $route(to, from) {
    //   if (to.path !== from.path) {
    //     this.$data.modalShowFlag = false;
    //   }
    // },
    newsList: {
      deep: true,
      handler(newValue, oldInput) {
        let count = String(
          this.newsList.filter((v: any) => v.checked === false).length,
        );
        if (Number(count) > 99) {
          count = '99+';
        }
        this.newNewsCount = count;
      },
    },
    login(newVal, oldVal) {
      if (newVal) {
        // ログイン成功時
        this.getAlertList();
      }
    },
  },
  directives: {
    ClickOutside,
  },
  methods: {
    onClickAlert() {
      this.modalShowFlag2 = false;
      this.modalShowFlag3 = !this.modalShowFlag3;
      if (this.displayedItems.length === 0) {
        this.noAlertFlag = true;
      }
      this.loading = false;
    },
    updateDisplayedItem(data?: any, id?: number) {
      if (data) {
        this.displayedItems = this.displayedItems.filter(val => {
          const valCategory = val.category === ''; // true: お知らせ, false: アラート通知
          const dataCategory = data.news_id >= 0; // true: お知らせ, false: アラート通知

          //  alertIDとカテゴリが一致する場合はdisplayedItemから削除
          return !(val.alertID === id && valCategory === dataCategory);
        });
        if (this.displayedItems.length === 0) {
          this.noAlertFlag = true;
        }
      }
    },
    onDetailModalClose() {
      // this.modalShowFlag = false;
      this.modalShowFlag2 = false;
      this.modalShowFlag3 = false;
    },
    onAnotherModal() {
      // スマホ実機でタップ時、ハンバーガーメニューを閉じる際にも発火してしまうため
      // モーダル外エリアクリック処理のタイミングを遅らせる
      // (iPhone7ではイベントの発生が遅いため500msにする)
      // 遅延の影響があるのはトップバーのアイコン以外をタップしてクローズしたとき
      setTimeout(() => {
        this.modalShowFlag2 = false;
      }, 500);
    },
    onAlertModalClose() {
      // onAnotherModalと同様に遅延させる
      setTimeout(() => {
        this.modalShowFlag3 = false;
      }, 500);
    },
    windowOpen(path: string) {
      window.open(path);
    },
    onPushPath(path: string, fromHamburger: boolean, index?: any, item?: any) {
      let viewMode = fromHamburger ? 'md=sp' : '';
      if (item && index) {
        viewMode = `&${viewMode}`;
        if (item.category === '') {
          this.$router.push(`/news?news_id=${index}${viewMode}`, () => {});
          // this.$router.push({ name: 'News', params: { news_id: index }});
        } else {
          this.$router.push(
            `/alert?alertid=${index}${viewMode}&alertType=${item.type}&title=${item.title}&date=${item.date}`,
            () => {},
          );
        }
      } else {
        viewMode = `?${viewMode}`;
        this.$router.push(`${path}${viewMode}`, () => {});
        this.$emit('pushPath', path);
      }
      this.onDetailModalClose();

      const fn = Dashboard.prototype.constructor.options.methods.onClickLogo;
      fn.call(this.$parent.$children[6]);

      if (item) {
        this.displayedItems = this.displayedItems.filter(val => {
          // return val.alertID !== item.alertID;
          const cat = (val.category === '') === (item.category === '');
          return !(val.alertID === item.alertID && cat);
        });

        if (this.displayedItems.length === 0) {
          this.noAlertFlag = true;
        }
      }
    },
    newsCount() {
      let count = String(this.newsList.length);
      if (Number(count) > 99) {
        count = '99+';
      }
      return count;
    },
    // pathが現在表示中の画面パスか？
    isActivePath(path: string) {
      return this.nowPath.indexOf(path) > -1;
    },
    // pathsに現在表示中の画面パスが含まれていたら'active'を返す。
    tryGetClassActiveByPaths(paths: string[]) {
      return paths.some( path => this.isActivePath(path) ) ? 'active' : '';
    },
    // pathが現在表示中の画面パスなら'active'を返す。
    tryGetClassActiveByPath(path: string) {
      return this.tryGetClassActiveByPaths([path]);
    },
    onClickShowGadgetEditer() {
      this.$emit('edit', new models.CGadget());
      this.$emit('openGadget');
    },
    onClickShowAddGadget() {
      this.$emit('openAdd');
    },
    onClickSPMenuOutSide() {
      this.modalShowFlag2 = false;
    },
    setNoAlertList() {
      const noAlertProps = {
        title: '新しい通知はありません。',
        alertID: -1,
      };
      const noAlertArray = [noAlertProps] as Talert.INewsAlert[];
      this.noAlertList = this.noAlertList.concat(noAlertArray);
    },
    async getAlertList() {
      if (!this.login) {
        return;
      }
      const api = new API();
      const param = {
        currentAlertID: this.minAlertID,
      } as alertModels.VNewsAlertPagination;
      const res = await api.get<alertModels.VNewsAlert>(
        'alert/top-bar-alert',
        param,
      );
      this.setNoAlertList();
      if (res.result) {
        if (res.data.alert.length > 0) {
          this.alertList = this.alertList.concat(res.data.alert);
          this.minAlertID = res.data.alert.reduce((a, b) =>
            a.alertID < b.alertID ? a : b,
          ).alertID;
          this.displayedItems = this.alertList;
          // this.displayedItems = this.alertList.map((v) => { return {id: v.alertID, title: v.title, date: v.date} });
        } else {
          this.noAlertFlag = true;
        }
      }
      // console.log('this.alertList',this.alertList)
      // console.log('res',res)
      // console.log('minAlertID',this.minAlertID)
      // else {
      //   this.$emit('change', NOC.APP.MODE.LOGIN);
      // }
      // list.map((v) => {
      //   return {id: v.manageID, contents: [moderator.name, moderator.mail]};
      // });
    },
    // openDetaile(data: any, key: any) {
    //   this.$emit('openDetaile', data, key);
    //   this.$emit('currentPage', this.page);
    // },
    async infiniteHandler($state: any) {
      // 無限ローディング対策
      if (!this.loading) {
        this.loading = true;
        const api = new API();

        const requestData = {
          // values: this.myValues,
          page: this.nextPage,
        };
        const res = await api.post<any, any>('alert/reload', requestData);

        if (res.result) {
          if (this.nextPage !== 0) {
            this.displayedItems = this.displayedItems.concat(res.data.items);
          } else {
            this.displayedItems = res.data.items;
            if (this.displayedItems.length > 0) {
              this.noAlertFlag = false;
            }
          }
          this.selectMaxCount = res.data.count;
          if (this.displayedItems.length < this.selectMaxCount) {
            $state.loaded();
          } else {
            $state.complete();
          }
          // this.nextPage++;
          this.nextPage = Math.floor(this.displayedItems.length / 10);
        }
        this.loading = false;
      }
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
